/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../script-hack/script-hack.component.ngfactory';
import * as i2 from '../../../../../app/shared/components/script-hack/script-hack.component';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../app/shared/components/google-adwords-conversion/google-adwords-conversion.component';
import * as i5 from '@angular/router';
import * as i6 from '../../../../../app/shared/services/google-pattern-number-formatter';
const styles_GoogleAdwordsConversionComponent:any[] = ([] as any[]);
export const RenderType_GoogleAdwordsConversionComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_GoogleAdwordsConversionComponent,data:{}});
function View_GoogleAdwordsConversionComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'script-hack',
      ([] as any[]),(null as any),(null as any),(null as any),i1.View_ScriptHackComponent_0,
      i1.RenderType_ScriptHackComponent)),i0.ɵdid(1,4374528,(null as any),0,i2.ScriptHackComponent,
      [i0.ChangeDetectorRef],{appendToBody:[0,'appendToBody']},(null as any)),(_l()(),
      i0.ɵted(2,0,['\n    gtag(\'event\', \'conversion\', ',');\n'])),i0.ɵpid(0,i3.JsonPipe,
      ([] as any[]))],(_ck,_v) => {
    const currVal_0:any = true;
    _ck(_v,1,0,currVal_0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = i0.ɵunv(_v,2,0,i0.ɵnov(_v,3).transform(_co.conversionData));
    _ck(_v,2,0,currVal_1);
  });
}
export function View_GoogleAdwordsConversionComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_GoogleAdwordsConversionComponent_1)),i0.ɵdid(1,16384,(null as any),0,i3.NgIf,
      [i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,
      _v) => {
    var _co:i4.GoogleAdwordsConversionComponent = _v.component;
    const currVal_0:any = _co.conversionData;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_GoogleAdwordsConversionComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'google-adwords-conversion',
      ([] as any[]),(null as any),(null as any),(null as any),View_GoogleAdwordsConversionComponent_0,
      RenderType_GoogleAdwordsConversionComponent)),i0.ɵdid(1,114688,(null as any),
      0,i4.GoogleAdwordsConversionComponent,[i5.ActivatedRoute,i6.GooglePatternNumberFormatter],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const GoogleAdwordsConversionComponentNgFactory:i0.ComponentFactory<i4.GoogleAdwordsConversionComponent> = i0.ɵccf('google-adwords-conversion',
    i4.GoogleAdwordsConversionComponent,View_GoogleAdwordsConversionComponent_Host_0,
    {offer:'offer'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2dvb2dsZS1hZHdvcmRzLWNvbnZlcnNpb24vZ29vZ2xlLWFkd29yZHMtY29udmVyc2lvbi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmM1NjA1OTk2NDQvc3JjL3NyYy9hcHAvc2hhcmVkL2NvbXBvbmVudHMvZ29vZ2xlLWFkd29yZHMtY29udmVyc2lvbi9nb29nbGUtYWR3b3Jkcy1jb252ZXJzaW9uLmNvbXBvbmVudC50cyIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2dvb2dsZS1hZHdvcmRzLWNvbnZlcnNpb24vZ29vZ2xlLWFkd29yZHMtY29udmVyc2lvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2dvb2dsZS1hZHdvcmRzLWNvbnZlcnNpb24vZ29vZ2xlLWFkd29yZHMtY29udmVyc2lvbi5jb21wb25lbnQudHMuR29vZ2xlQWR3b3Jkc0NvbnZlcnNpb25Db21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8c2NyaXB0LWhhY2sgW2FwcGVuZFRvQm9keV09XCJ0cnVlXCIgKm5nSWY9XCJjb252ZXJzaW9uRGF0YVwiPlxuICAgIGd0YWcoJ2V2ZW50JywgJ2NvbnZlcnNpb24nLCB7eyBjb252ZXJzaW9uRGF0YXxqc29uIH19KTtcbjwvc2NyaXB0LWhhY2s+IiwiPGdvb2dsZS1hZHdvcmRzLWNvbnZlcnNpb24+PC9nb29nbGUtYWR3b3Jkcy1jb252ZXJzaW9uPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTt1Q0FBQSxVQUFBO01BQUEsd0VBQTBEO2FBQUE7TUFBQTtJQUE3QztJQUFiLFdBQWEsU0FBYjs7O0lBQTBEO0lBQUE7Ozs7b0JBQTFEO01BQUEsaURBQUE7TUFBQTs7O0lBQW1DO0lBQW5DLFdBQW1DLFNBQW5DOzs7O29CQ0FBO01BQUE7aURBQUEsVUFBQTtNQUFBO01BQUE7SUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/$$_gendir/app/shared/components/google-adwords-conversion/google-adwords-conversion.component.ngfactory.ts